export const host = process.env.NODE_ENV === 'production' ? '' : 'https://identity.osp7.ru'